import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';

const InsurersRow = ({ name }) => (
  <TableRow hover>
    <TableCell>{name}</TableCell>
  </TableRow>
);

InsurersRow.propTypes = {
  name: PropTypes.string
};

export default InsurersRow;
